import React, { useState, useEffect } from 'react';
import { VscCheck, VscTrash, VscBug, VscCommentDiscussion } from 'react-icons/vsc';
import { getFeedback, markFeedbackDone, deleteFeedback } from '../../api/feedback';
import './FeedbackPanel.css';

function fmtDate(d) {
  return new Date(d).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' }) + ' ' +
    new Date(d).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function FeedbackPanel({ onCountChange }) {
  const [items, setItems] = useState([]);

  const load = () => getFeedback().then(r => setItems(r.data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const handleDone = async (id) => {
    const res = await markFeedbackDone(id).catch(() => null);
    if (!res) return;
    setItems(prev => prev.map(i => i._id === id ? res.data : i));
    onCountChange?.();
  };

  const handleDelete = async (id) => {
    if (!confirm('Delete this report?')) return;
    await deleteFeedback(id).catch(() => {});
    setItems(prev => prev.filter(i => i._id !== id));
    onCountChange?.();
  };

  const open = items.filter(i => i.status === 'open');
  const done = items.filter(i => i.status === 'done');

  const renderItem = (item) => (
    <div key={item._id} className={`fb-item${item.status === 'done' ? ' fb-done' : ''}`}>
      <div className="fb-item-header">
        <span className={`fb-type-badge fb-type-${item.type}`}>
          {item.type === 'bug' ? <VscBug size={12} /> : <VscCommentDiscussion size={12} />}
          {item.type === 'bug' ? 'Bug' : 'Feedback'}
        </span>
        <span className="fb-user">{item.user?.displayName || item.user?.username}</span>
        <span className="fb-role">({item.user?.role})</span>
        <span className="fb-date">{fmtDate(item.createdAt)}</span>
        <div className="fb-actions">
          {item.status === 'open' && (
            <button className="btn-icon" title="Mark done" onClick={() => handleDone(item._id)}>
              <VscCheck size={14} />
            </button>
          )}
          <button className="btn-icon" title="Delete" onClick={() => handleDelete(item._id)}>
            <VscTrash size={14} />
          </button>
        </div>
      </div>
      <div className="fb-message">{item.message}</div>
    </div>
  );

  return (
    <div className="fb-panel module-wrap">
      <div className="module-toolbar">
        <span className="module-toolbar-title">Feedback & Bug Reports</span>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{open.length} open · {done.length} done</span>
      </div>

      {items.length === 0 && (
        <div className="empty-state">No reports yet.</div>
      )}

      {open.length > 0 && (
        <div className="fb-section">
          <div className="fb-section-title">Open ({open.length})</div>
          {open.map(renderItem)}
        </div>
      )}

      {done.length > 0 && (
        <div className="fb-section">
          <div className="fb-section-title">Done ({done.length})</div>
          {done.map(renderItem)}
        </div>
      )}
    </div>
  );
}

export default FeedbackPanel;
